/** One BarmetHub catalog for business connectors and internal Nexus capabilities.
 * Catalog membership is not a configured connection or an authorization grant.
 * Credentials must stay server-side; no credential value belongs in this model.
 */
export interface HubIntegrationDefinition {
  id: string; name: string; kind: 'BUSINESS' | 'INFRASTRUCTURE' | 'INTERNAL';
  verification: 'UNVERIFIED';
}
export const hubIntegrations: readonly HubIntegrationDefinition[] = [
  ['holded', 'Holded', 'BUSINESS'], ['clientify', 'Clientify', 'BUSINESS'],
  ['gmail', 'Gmail', 'BUSINESS'], ['calendar', 'Calendar', 'BUSINESS'],
  ['drive', 'Drive', 'BUSINESS'], ['wordpress', 'WordPress', 'BUSINESS'],
  ['woocommerce', 'WooCommerce', 'BUSINESS'], ['prestashop', 'PrestaShop', 'BUSINESS'],
  ['semrush', 'Semrush', 'BUSINESS'], ['search-console', 'Search Console', 'BUSINESS'],
  ['metricool', 'Metricool', 'BUSINESS'], ['github', 'GitHub', 'INFRASTRUCTURE'],
  ['cloudflare', 'Cloudflare', 'INFRASTRUCTURE'], ['plesk', 'Plesk', 'INFRASTRUCTURE'],
  ['hermes', 'Hermes', 'INTERNAL'], ['mcp', 'MCP', 'INTERNAL'],
  ['stripe', 'Stripe', 'BUSINESS'], ['paypal', 'PayPal', 'BUSINESS'],
  ['resend', 'Resend', 'BUSINESS'], ['anthropic', 'Anthropic', 'BUSINESS'],
  ['runway', 'Runway', 'BUSINESS'],
].map(([id, name, kind]) => ({ id, name, kind: kind as HubIntegrationDefinition['kind'], verification: 'UNVERIFIED' }));
